import { useMemo } from 'react';
import { differenceInCalendarDays, format, parseISO } from 'date-fns';

export function useDays(startIso, endIso) {
  return useMemo(() => {
    if (!startIso || !endIso) return [];
    const start = new Date(startIso);
    const end = new Date(endIso);
    const total = Math.max(1, differenceInCalendarDays(end, start) + 1);
    return Array.from({ length: total }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return {
        iso: format(d, 'yyyy-MM-dd'),
        day: format(d, 'dd'),
        dow: format(d, 'EEE'),
        date: d,
      };
    });
  }, [startIso, endIso]);
}

// Normalize an ISO date-time string to a local date-only (midnight)
// to avoid timezone shifts.
export function toDateOnly(isoString) {
  if (!isoString) return null;
  try {
    const datePart = String(isoString).slice(0, 10);
    return new Date(datePart + 'T00:00:00');
  } catch (e) {
    try {
      const d = parseISO(isoString);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    } catch {
      return null;
    }
  }
}



